import {Component, Object3D, WonderlandEngine} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {CustomLogTag} from '../classes/Constants.js';
import {Puzzle} from './puzzle.js';
import {DefaultGameRules} from './rules/default-game-rules.js';
import {BoardColor} from './board-object.js';
import {Environment} from './environment.js';

export enum Area {
    Arctic,
    Desert,
    Forest,
    Island,
    Swamp,
    Candy,
    Moon,
    WukArea,
}

export class LevelSelect extends Component {
    static TypeName = 'level-select';
    @property.string('Island Environment')
    islandName = 'Island Environment';

    @property.string('Candyland Environment')
    candylandName = 'Candyland Environment';

    private _levelMap = new Map<Area, string>([
        [Area.Island, 'Area-Island.bin'],
        [Area.Candy, 'Area-Candyland.bin'],
    ]);

    // Singleton
    private static _levelSelectInstance: LevelSelect;
    private _currentLevel: any;
    static get instance(): LevelSelect {
        return LevelSelect._levelSelectInstance;
    }

    private _currentEnvironment: Environment;
    private _selectedEnvironment = '';

    init() {
        if (LevelSelect._levelSelectInstance) {
            this.engine.log.error(
                CustomLogTag.Game,
                'There can only be one instance of LevelSelect Component'
            );
        }

        LevelSelect._levelSelectInstance = this;
    }

    start(): void {
        this._selectedEnvironment = this.islandName;
        //  this.load();
    }

    colorAcceptable(color: BoardColor): boolean {
        let numColors = 0;
        const myRules = Puzzle.instance.rules as DefaultGameRules;

        if (myRules) {
            numColors = myRules.numberOfFruitColors;
        }
        return this._currentEnvironment.colorAcceptable(color, numColors);
    }

    async load() {
        await this._loadEnvironment(this._selectedEnvironment);
    }

    nextEnvironment() {
        this._currentEnvironment.showNext();
    }

    changeLevelTutorial() {
        this._selectedEnvironment = this.islandName;
        // do not save the last area in this case
    }

    private async _loadEnvironment(environmentName: string) {
        if (this._currentLevel === environmentName) {
            return; // already loaded
        }
        const level = await this.engine.loadPrefab(this._levelMap.get(Area.Island));
        //const level = await this.engine.loadPrefab(this._levelMap.get(Area.Candy));
        const instance = this.engine.scene.instantiate(level);
        instance.root.parent = this.object;
        this._currentLevel = environmentName;
        this._currentEnvironment = this.object
            .findByNameRecursive(environmentName)[0]
            .getComponent(Environment);
    }
}
